import { ThumbsUp, AlertTriangle, CheckCircle2, XCircle, FileText } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { RockStatus } from '../types';

interface RockStatusBadgeProps {
  status: RockStatus;
  className?: string;
}

const STATUS_CONFIG: Record<
  RockStatus,
  { label: string; icon: React.ReactNode; className: string }
> = {
  on_track: {
    label: 'On Track',
    icon: <ThumbsUp className="h-3 w-3" />,
    className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100',
  },
  off_track: {
    label: 'Off Track',
    icon: <AlertTriangle className="h-3 w-3" />,
    className: 'bg-red-100 text-red-800 border-red-200 hover:bg-red-100',
  },
  complete: {
    label: 'Complete',
    icon: <CheckCircle2 className="h-3 w-3" />,
    className: 'bg-green-100 text-green-800 border-green-200 hover:bg-green-100',
  },
  canceled: {
    label: 'Canceled',
    icon: <XCircle className="h-3 w-3" />,
    className: 'bg-gray-100 text-gray-500 border-gray-200 hover:bg-gray-100 line-through',
  },
  draft: {
    label: 'Draft',
    icon: <FileText className="h-3 w-3" />,
    className: 'bg-transparent text-muted-foreground border border-border hover:bg-transparent',
  },
};

export function RockStatusBadge({ status, className }: RockStatusBadgeProps) {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.draft;

  return (
    <Badge
      variant="outline"
      className={cn('flex items-center gap-1 text-xs font-medium', config.className, className)}
    >
      {config.icon}
      {config.label}
    </Badge>
  );
}
